// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#ooh_amap{position:relative}#container{width:100%;color:#333}#myPageTop{position:absolute;color:#333;top:10px;left:10px}#tipinput{width:200px}.amap-sug-result{z-index:9999;color:#333}", ""]);
// Exports
module.exports = exports;
